import script from "./custom-page-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./custom-page-view.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__